import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	goBack: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	goBack: {
		id: 'command-palette.modal.modal-content.header.go-back',
		defaultMessage: 'Go back',
		description:
			'Tooltip message that is displayed when user hovers over the back button on the command palette',
	},
});
export default messages;
